<template>
  <v-dialog v-model="dialog" width="560" @click:outside="cancel">
    <v-card>
      <v-card-title>
        <h3><strong>{{ $t('resultExportConfirmDialog.label.title') }}</strong></h3>
      </v-card-title>
      <v-card-text>
        <!-- 行の出力：出力済の伝票の再出力確認（前回出力日時・操作者） -->
        <template v-if="mode === 'ROW'">
          <div class="mb-2">{{ $t('resultExportConfirmDialog.label.rowMessage') }}</div>
          <div v-for="(r, i) in reexports" :key="i" class="text-grey-darken-1">
            {{ $t('resultExport.label.voucherTypeItem.' + r.voucherType) }} / {{ r.voucherNo }}<br />
            {{ $t('resultExportConfirmDialog.label.lastExported', [fmtDateTime(r.lastExportedAt), whoLabel(r.lastExportedBy)]) }}
          </div>
        </template>
        <!-- まとめて出力：出力済を含む場合の選択 -->
        <template v-else>
          <div class="mb-2">{{ $t('resultExportConfirmDialog.label.bulkMessage', [reexports.length]) }}</div>
          <v-radio-group v-model="includeExported" hide-details density="compact">
            <v-radio :label="$t('resultExportConfirmDialog.label.includeExported')" :value="true" />
            <v-radio :label="$t('resultExportConfirmDialog.label.unexportedOnly')" :value="false" :disabled="unexportedCount === 0" />
          </v-radio-group>
        </template>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn text @click="cancel"> {{ $t('common.action.cancel') }} </v-btn>
        <v-btn color="indigo darken-1" dark @click="ok"> {{ $t('common.action.ok') }} </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    mode: { type: String, required: true },          // ROW / BULK
    reexports: { type: Array, required: true },      // 出力済の伝票（前回出力日時・出力者）
    unexportedCount: { type: Number, default: 0 },   // まとめて出力：選択中の未出力伝票数
    handleCancel: { type: Function, required: true },
    handleOk: { type: Function, required: true },
  },
  data() {
    return {
      dialog: true,
      includeExported: true,
    };
  },
  methods: {
    fmtDateTime(v) {
      if (!v) return "—";
      const d = new Date(v);
      if (isNaN(d.getTime())) return v;
      const p = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}/${p(d.getMonth() + 1)}/${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`;
    },
    // 出力者：履歴なし（フラグのみ）・SYSTEM は中継プログラムの自動出力
    whoLabel(by) {
      if (!by || by === "SYSTEM") return this.$t("resultExport.label.autoBy");
      return by;
    },
    cancel() {
      this.handleCancel();
    },
    ok() {
      this.handleOk(this.mode === "ROW" ? true : this.includeExported);
    },
  },
};
</script>
